import React from 'react'
import { useQuery } from '@tanstack/react-query'
import PrivateEventsPictureGallery from './PrivateEventsPictureGallery'
import { EventsSectionContainer } from '../../styles/EventsPages/EventsSection'
import { fetchPrivateEventsGallery } from '../../services/api'
import { EventsTypes } from '../../interfaces/types'

const PrivateEventsSection: React.FC = () => {
    const { data: eventTypes = [] } = useQuery<EventsTypes[]>({
        queryKey: ['private-events-gallery'],
        queryFn: fetchPrivateEventsGallery,
    })

    return (
        <EventsSectionContainer>
            {eventTypes?.map((event, index) => (
                <PrivateEventsPictureGallery 
                key={index} 
                eventsType={event}
                side={index % 2 === 0 ? 'right' : 'left'} />
            ))}
        </EventsSectionContainer>
    )
}

export default PrivateEventsSection